export { default } from './Header';



// WEBPACK FOOTER //
// ./src/lauoyts/LayoutApp/Header/index.js